// extracted by mini-css-extract-plugin
module.exports = {"container":"_e5bdb1a","name":"_50ea763","tightDetail":"_eef8dd2"};